import React from 'react';
import Nav from '../Nav';
import Video from '../Video';


const ExtraItemPage = ({...props}) => {

    console.log('extra page props: ', props)

    const getConnectingQuestions = () => {
        return props.location.state.video.connectingQuestions ? CQComponent(props.location.state.video.connectingQuestions) : ''
    };

    const CQComponent = (CQSource) => {
        return <div className="connecting-questions">
            <a href={CQSource} target="_blank">
                <button className="yellow-btn">Connecting Questions</button>
            </a>
        </div>
    }

    const styleTitle = (string) => {
        if (string === "Self-Discovery") {
            return string;
        }
        return string.replace(/-/g, " ");
    }

    let pageTitle = styleTitle(props.match.params.slug);
    return (
        <div id="extra-item-page">
            <Nav/>
            <h2 className="page-title">{pageTitle}</h2>
            <div id="video-container">
                <Video src={props.location.state.video.videoSource}/>
                <div className="button-container">
                    {getConnectingQuestions()}
                </div>
                <div className="back-to-extras-container">
                        <a className="button ghost-button" href="/extras">Back to Extras Page</a>
                </div>
            </div>

        </div>
    );


};

export default ExtraItemPage;
